import { CircularProgress, Stack } from '@mui/material';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { InboxFeatureRoute } from './InboxFeatureRoute';

const InboxShell = lazy(() => import('@frontend/router/inbox'));

export const InboxRoute = () => {
  const { t } = useTranslation();

  return (
    <InboxFeatureRoute>
      <Suspense
        fallback={
          <Stack height="100%" alignItems="center" justifyContent="center">
            <CircularProgress aria-label={t('inbox.loading')} />
          </Stack>
        }
      >
        <InboxShell />
      </Suspense>
    </InboxFeatureRoute>
  );
};
